import { fetchListVerificacion, fetchAdministracion } from "./http-common";
import {
  ITablaListaVerificacion,
  IDetalleListaVerificacion,
  IRevisionListaVerificacion,
  IAuditoria,
  IRequetTableHistorico,
} from "../Interfaces/IListaVerificacion";
import { ISearch } from "../Interfaces/base/IBase";
import { Ifilter } from "../Interfaces/filter";
import {
  IFilterListaVerificacion,
  IFilterPendienteMx,
} from "../pages/listaVerificacion/mantenimiento";

const urlListaVerificacion = "ListaVerificacion";

const getTabla = (filter: Ifilter, body: object) => {
  return fetchListVerificacion.post<ITablaListaVerificacion>(
    `${urlListaVerificacion}/Tabla?skip=${filter.skip}&take=${filter.take}&Search=${filter.search}`,
    body
  );
};

const getDetalle = (id: any) => {
  return fetchListVerificacion.get<IDetalleListaVerificacion>(
    `${urlListaVerificacion}/Detalle?id=${id}`
  );
};

const postRevisionMantenimiento = (body: IRevisionListaVerificacion) => {
  return fetchListVerificacion.post(
    `${urlListaVerificacion}/Validar/Mantenimiento`,
    body
  );
};

const postAuditoria = (body: IAuditoria) => {
  return fetchListVerificacion.post(
    `${urlListaVerificacion}/Validar/Mantenimiento`,
    body
  );
};

const postTablaHistorial = (body: IRequetTableHistorico) => {
  return fetchListVerificacion.post(`${urlListaVerificacion}/Historico`, body);
};

const postTablaHistorialMX = (body: IFilterPendienteMx) => {
  return fetchListVerificacion.post(
    `${urlListaVerificacion}/PendientesMx`,
    body
  );
};

const listarEquipoModelos = (query: any) => {
  return fetchListVerificacion.get(`/EquipoModelo?Skip=0&Take=100`);
};

const personaByCustomer = (filter: ISearch) => {
  return fetchAdministracion.get(`Persona/Combo/ByCustomer`, {
    params: filter,
  });
};

const listarAutorizaciones = (query: any) => {
  return fetchListVerificacion.post(
    `/AutorizacionEquipoModelo/Autorizaciones`,
    query
  );
};

const crearAutorizacion = (body: any) => {
  return fetchListVerificacion.post(`/AutorizacionEquipoModelo`, body);
};

const AutorizacionPersonaEquipo = (body: any) => {
  return fetchListVerificacion.post(`AutorizacionEquipoModelo/Autorizar`, body);
};

const eliminarAutorizacion = (body: any) => {
  return fetchListVerificacion.put(
    `AutorizacionEquipoModelo/EliminiarModeloEquipoPersona`,
    body
  );
};

/**Lista Model-equipos */
const listaModeloEquipo = (filters: Ifilter) => {
  return fetchListVerificacion.get(`EquipoModelo?`, { params: filters });
};
/**Lista Esquipos */
const listaEquipos = (
  filters: Ifilter,
  controller = new AbortController()
) => {
  return fetchListVerificacion.get(`Equipo`, { 
    params: filters,
    signal: controller.signal,
  });
};

/**Lista Estados */
const listaEstados = () => {
  return fetchListVerificacion.get(`Estado`);
};

/**Lista Tipo Esquipos */
const listaTipoEquipos = (
  filters: Ifilter,
  controller = new AbortController()
) => {
  return fetchListVerificacion.get(`Equipo/TipoEquipos`, { 
    params: filters,
    signal: controller.signal,
  });
};

// Listar imgBlob en base 64
const listarImgMantenimiento = (body: any) => {
  return fetchListVerificacion.post(
    `${urlListaVerificacion}/TablaAdjuntos`,
    body
  );
};

// Listar imgBlob en base 64
const listarImgHistorial = (body: any) => {
  return fetchListVerificacion.post(
    `${urlListaVerificacion}/HistoricoAdjuntos`,
    body
  );
};

const ListaVerificacionService = {
  getTabla,
  getDetalle,
  postRevisionMantenimiento,
  postTablaHistorial,
  listarEquipoModelos,
  personaByCustomer,
  listarAutorizaciones,
  crearAutorizacion,
  eliminarAutorizacion,
  postAuditoria,
  listaModeloEquipo,
  listaEquipos,
  listaEstados,
  listaTipoEquipos,
  postTablaHistorialMX,
  AutorizacionPersonaEquipo,
  listarImgMantenimiento,
  listarImgHistorial,
};

export default ListaVerificacionService;
